import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=fdb22c3e&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=fdb22c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb22c3e",
  null
  
)

export default component.exports